var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-dropdown',_vm._b({attrs:{"items":_vm.dropdownItems},on:{"changeAutocomlite":_vm.changeAutocomlite}},'ui-dropdown',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }